// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"405":"8729d2fcba72ae8f","888":"a2fa0d3a85edfaa9"}[chunkId] + ".css";
};